import React from "react";
import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "34633821110";
const WHATSAPP_MSG = encodeURIComponent(
  "Hola Elecars, me gustaría recibir asesoramiento sobre la importación de un vehículo desde Alemania."
);

export const WhatsAppFab = () => {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MSG}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      className="fixed bottom-6 right-6 sm:bottom-8 sm:right-8 z-50 w-14 h-14 bg-[#25D366] hover:bg-[#1ebd5a] rounded-full flex items-center justify-center shadow-[0_8px_32px_rgba(37,211,102,0.45)] hover:scale-110 transition-all duration-300"
      aria-label="WhatsApp"
    >
      <MessageCircle className="w-6 h-6 text-white" strokeWidth={1.8} />
      <span className="absolute inset-0 rounded-full animate-ping bg-[#25D366]/40" />
    </a>
  );
};

export default WhatsAppFab;
